<div class="migrate-container">
  <div class="header-row">
    <div class="title-section">
      <h2>Join a Community</h2>
      <p>Migrate your family tree to a new community.</p>
    </div>
    <ion-button fill="clear" color="medium" (click)="close.emit()">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="input-section">
    <ion-item lines="none" class="custom-input">
      <ion-label position="stacked">Paste your invite link</ion-label>
      <ion-input [(ngModel)]="inviteLink" placeholder="https://app.vanshavali.com/invite/..."></ion-input>
    </ion-item>
  </div>

  <div class="button-section">
    <ion-button expand="block" (click)="joinCommunity()" [disabled]="!inviteLink">
      Join Community
    </ion-button>
  </div>
</div>
